var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[(!_vm.isElIcon)?_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconFont}})]):_vm._e(),(_vm.isElIcon)?_c('i',{class:_vm.code}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }